<template>
	<div class="layout">
		<div class="list-base">
			<div class="list-base-left">
				<Tag color='magenta' size='large' v-show="documentItem.checkState == 1">已创建</Tag>
				<Tag color='red' size='large' v-show="documentItem.checkState == 2">已过账</Tag>
				<Tag color='success' size='large' v-show="documentItem.checkState == 3">已完结</Tag>
				<span class="list-base-left-span">采购退货单：{{documentItem.code}}</span>
			</div>
			<div class="list-base-right">
				<span class="list-base-right-span">
					业务员：
					<span class="span-back-color">{{documentItem.userName}}</span>
				</span>
				<span class="list-base-right-span">
					业务日期：
					<span class="span-back-color">{{documentItem.businessDate}}</span>
				</span>
				<span class="list-base-right-span">
					本单金额：
					<span class="span-back-color">¥{{documentItem.originalPrice}}</span>
				</span>
			</div>
		</div>
		<div class='list-module'>
			<div class="div-title">
				<div class="div-title-label">
					基础信息
				</div>
			</div>
			<Row class="div-content-row">
				<Col span="8">单据编号：{{documentItem.code}}</Col>
				<Col span="8">业务日期：{{documentItem.businessDate}}</Col>
				<Col span="8">业务员：{{documentItem.userName}}</Col>
			</Row>
			<Row class="div-content-row">
				<Col span="8">供应商：{{documentItem.supplierName}}</Col>
				<Col span="8">备注：{{documentItem.note}}</Col>
			</Row>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					商品信息
				</div>
			</div>
			<Table :columns="commodityColumn" :data="documentItem.returnDetailList"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					额外费用
				</div>
			</div>
			<div>
				<span style="padding-left:20px;">
					注：“我方垫付”影响应付款减少；“对方垫付”影响应付款增加；“我方自付”不影响应付款
				</span>
			</div>
			<div>
				<table class="extraCostShowTable">
					<tr v-for="item in documentItem.extraCostInfos">
						<td>{{item.type}}：</td>
						<td>{{item.advancePayWay}}￥{{item.amount}}</td>
						<td>（{{item.payAccount}}）</td>
					</tr>
				</table>
			</div>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					物流信息
				</div>
			</div>
			<Table :columns="logisticsInfoColumn" :data="documentItem.logisticsInfos"></Table>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					结算信息
				</div>
			</div>
			<Row class="div-content-row-center">
				<Col span="8">折后金额：<span class="amount-color">{{documentItem.amount}}</span></Col>
				<Col span="8">已收定金：<span class="amount-color">{{documentItem.payAmount}}</span></Col>
				<Col span="8">待收金额：<span class="amount-color">{{formatNum(documentItem.amount - documentItem.payAmount)}}</span>
				</Col>
			</Row>
			<div class="div-content-detail">
				<div class="div-content-detail-title">
					付款详情
				</div>
				<div class="div-content-detail-list" v-show="documentItem.payAmount>0">
					<div class="div-content-detail-list-title">定金</div>
					<div class="div-content-detail-list-content">
						<div class="div-content-detail-list-content-item">
							付款日期：
							<span class="span-back-color">
								{{documentItem.businessDate}}
							</span>
						</div>
						<div class="div-content-detail-list-content-item">
							{{documentItem.payWay}}：
							<span class="span-back-color">
								¥&nbsp;{{documentItem.payAmount}}
							</span>
						</div>
					</div>
				</div>
				<div class="div-content-detail-list" v-show="receiptDetail.length>0">
					<div class="div-content-detail-list-title">收款单收款</div>
					<div class="div-content-detail-list-content" v-for="(item,index) in receiptDetail">
						<div class="div-content-detail-list-content-item">
							收款日期：
							<span class="span-back-color">
								{{item.businessDate}}
							</span>
						</div>
						<div class="div-content-detail-list-content-item">
							{{item.receiptList.payWay}}：
							<span class="span-back-color">
								¥&nbsp;{{item.amountUnpaid}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="list-module">
			<div class="div-title">
				<div class="div-title-label">
					附件信息
				</div>
			</div>
			<DocumentFile :fileList='documentItem.fileList' :isShow='true'></DocumentFile>
		</div>
		<div class="list-module" style="display: flex;justify-content: flex-end;">
			<button class="jxyd-button jxyd-primary" title="打印单据" @click="printDocument()">
				<Icon type="md-print" size='18' />
				打印
			</button>
			<button class="jxyd-button jxyd-primary" title="复制单据" @click="copyDocument(documentItem)">
				<Icon type="md-print" size='18' />
				复制
			</button>
		</div>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import DocumentFile from '@/components/DocumentFile'
	import printMixin from '@/mixins/printMixin' // 引入打印 mixin
	export default {
		name: 'returnlistdetail',
		mixins: [printMixin],
		components: {
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					amount: 0,
					deposit: 0,
					returnDetailList: [],
					supplierId: '',
					supplierName: '',
					supplierDiscount: '100',
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					payWay: '',
					checkState: 1, //未审核
					fileList: []
				},
				commodityColumn: [{
						title: '商品',
						key: 'name',
						fixed: 'left',
						width: 345
					},
					{
						title: '单位',
						key: 'unit',
						width: 130
					},
					{
						title: '规格',
						key: 'format',
						width: 140,
					},
					{
						title: '批次号',
						key: 'batchCode',
						width: 200,
						render: (h, params) => {
							return h('span', {}, params.row.batchCode.join(','));
						}
					},
					{
						title: '当前库存',
						key: 'stock',
						width: 140,
						render: (h, params) => {
							return h('span', {}, this.getCurrentIStock(params.index))
						}
					},
					{
						title: '数量',
						key: 'quantity',
						width: 130
					},
					{
						title: '单价',
						key: 'price',
						width: 140
					},
					{
						title: '折扣(%)',
						key: 'discount',
						width: 140
					},
					{
						title: '折后单价',
						key: 'priceAfterDiscount',
						width: 140
					},
					{
						title: '总金额',
						key: 'amount',
						width: 200
					},
					// {
					// 	title: '备注',
					// 	key: 'note',
					// 	width: 350,
					// }
				],
				receiptDetail: [],
				logisticsInfoColumn: [{
						title: '物流公司',
						key: 'companyName'
					},
					{
						title: '物流单号',
						key: 'code'
					},
					{
						title: '收货人',
						key: 'receiver'
					},
					{
						title: '运费',
						key: 'freight'
					},
					{
						title: '说明',
						key: 'note'
					}
				]
			}
		},

		methods: {
			getReturnList(returnListId) {
				let self = this;
				request.get('/api/ReturnList/GetReturnList', {
					params: {
						id: returnListId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
					self.getPayDetail(self.documentItem.code);
				}).catch(function(error) {})
			},
			getCurrentIStock(index) {
				let commodityInventorys = this.documentItem.returnDetailList[index].commodity
					.commodityInventorys;
				if (!commodityInventorys) {
					return 0;
				}
				let stock = 0;
				for (let i = 0; i < commodityInventorys.length; i++) {
					if (commodityInventorys[i].commodityPriceType == this.documentItem.returnDetailList[index].format) {
						stock += commodityInventorys[i].stock;
					}
				}
				let extraUnits = this.documentItem.returnDetailList[index].commodity.extraUnits;
				if (extraUnits) {
					extraUnits.forEach(item => {
						if (item.unit == this.documentItem.returnDetailList[index].unit) {
							stock = item.conversionRate * stock;
						}
					});
				}
				return formatNum(stock);
			},
			getReturnListByCode(returnListCode) {
				let self = this;
				request.get('/api/ReturnList/GetReturnListByCode', {
					params: {
						code: returnListCode
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
					self.getPayDetail(self.documentItem.code);
				}).catch(function(error) {})
			},
			getPayDetail(code) {
				let self = this;
				request.get('/api/ReceiptList/GetReceiptDetail', {
					params: {
						code: code
					}
				}).then(function(response) {
					if (response.state == 0) {
						
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.receiptDetail = response.data;
				}).catch(function(error) {})
			},
			async copyDocument(param) {
				let self = this;
				await this.$Modal.confirm({
					title: "操作警告",
					content: "是否复制单据？",
					async onOk() {
						let result = await request.get('api/ReturnList/GetNextCode', {
							params: {
								prefix: 'CTH'
							}
						});
						if (!result || result.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '获取编号失败'
							});
							return;
						}
						let data = JSON.parse(JSON.stringify(param));
						data.id = 0;
						data.code = result.data;
						data.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
						data.createDate = data.businessDate;
						data.userId = parseInt(localStorage.getItem("userId"));
						data.userName = localStorage.getItem("userName");
						data.creator = parseInt(localStorage.getItem("userId"));
						data.checkState = 1;
						self.dataSubmitAndCheck(data);
					},
					onCancel() {}
				});
			},
			formatNum(value) {
				// 调用导入的 formatNum 函数
				return formatNum(value);
			},
			printDocument() {
				const printData = this.formatPrintData([this.documentItem])
				// 使用 mixin 提供的打印方法
				this.printWithTemplate(printData, 'purchaseReturnList')
			},
			formatPrintData(rawData) {
			    // 解析JSON字符串
			    let data = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
			    if (!Array.isArray(data)) data = [data];
			
			    // 辅助函数：添加序号（不包含合计行）
			    const addSerialNo = (arr) => arr.map((item, idx) => ({ ...item, serialNo: idx + 1 }));
			
			    // 计算合计（传入数组和字段名列表）
			    const calcTotals = (arr, fields) => {
			        const totals = {};
			        fields.forEach(f => { totals[f] = 0; });
			        arr.forEach(item => {
			            fields.forEach(f => {
			                totals[f] += (item[f] || 0);
			            });
			        });
			        return totals;
			    };
			
			    // 格式化单条记录
			    const formatSingle = (record) => {
			        // 商品明细表原始数据（无序号）
			        let commodityRaw = (record.returnDetailList || []).map(item => ({
			            name: item.name,
			            format: item.format,
			            unit: item.unit,
			            quantity: item.quantity,
			            price: item.price,
			            discount: item.discount,
			            amount: item.amount
			        }));
			        // 添加序号
			        let commodityDetail = addSerialNo(commodityRaw);
			        // 添加合计行（如果有数据）
			        if (commodityRaw.length > 0) {
			            const totals = calcTotals(commodityRaw, ['quantity', 'amount']);
			            commodityDetail.push({
			                serialNo: '',
			                name: '',
			                format: '',
			                unit: '合计',
			                quantity: totals.quantity,
			                price: '',
			                discount: '',
			                amount: totals.amount,
			                __style__: { fontWeight: 'bold', backgroundColor: '#f9f9f9' }
			            });
			        }
			
			        // 额外费用表
			        let extraRaw = (record.extraCostInfos || []).map(item => ({
			            type: item.type,
			            advancePayWay: item.advancePayWay,
			            payAccount: item.payAccount,
			            amount: item.amount,
			            note: item.note
			        }));
			        let extraCost = addSerialNo(extraRaw);
			        if (extraRaw.length > 0) {
			            const totals = calcTotals(extraRaw, ['amount']);
			            extraCost.push({
			                serialNo: '',
			                type: '',
			                advancePayWay: '',
			                payAccount: '合计',
			                amount: totals.amount,
			                note: '',
			                __style__: { fontWeight: 'bold', backgroundColor: '#f9f9f9' }
			            });
			        }
			
			        // 物流信息表
			        let logisticsRaw = (record.logisticsInfos || []).map(item => ({
			            companyName: item.companyName,
			            code: item.code,
			            receiver: item.receiver,
			            telephone: item.telephone,
			            freight: item.freight,
			            note: item.note
			        }));
			        let logisticsInfos = addSerialNo(logisticsRaw);
			        if (logisticsRaw.length > 0) {
			            const totals = calcTotals(logisticsRaw, ['freight']);
			            logisticsInfos.push({
			                serialNo: '',
			                companyName: '',
			                code: '',
			                receiver: '合计',
			                telephone: '',
			                freight: totals.freight,
			                note: '',
			                __style__: { fontWeight: 'bold', backgroundColor: '#f9f9f9' }
			            });
			        }
			
			        // 构建最终打印数据对象
			        return {
			            //title: "采购单",
			            code: record.code,
			            userName: record.userName,
			            businessDate: record.businessDate ? record.businessDate.split(' ')[0] : '',
			            supplierName: record.supplierName,
			            discount: record.supplierDiscount,
			            originalPrice: record.originalPrice,
			            amount: record.amount,
			            payAmount: record.payAmount,
			            payWay: record.payWay,
			            note: record.note,
			            commodityDetail: commodityDetail,
			            extraCost: extraCost,
			            logisticsInfos: logisticsInfos
			        };
			    };
			
			    return data.map(record => formatSingle(record));
			},
			dataSubmitAndCheck(data) {
				let self = this
				request.post('api/ReturnList/EditReturnList', data).then(function(result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败'
						});
						return
					}
					//记录采购退货单操作
					let log = {
						FlowId: result.data,
						Title: '采购退货单日志',
						OperationContent: '创建了此采购退货单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败'
							});
							return;
						}
					}).catch(err => {})
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '复制成功'
					});
				}).catch(err => {})
			},
		},
		watch: {
			'$route.query.returnListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getReturnList(param);
					}
				}
			},
			'$route.query.returnListCode': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getReturnListByCode(param);
					}
				}
			}
		},
		created: function() {}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.list-base {
		background-color: white;
		padding: 15px;
		overflow: hidden;
	}

	.list-base-left {
		float: left;
		display: flex;
		color: #000;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 100%;
		/* 父元素需要固定高度或其他百分比高度 */
	}

	.list-base-left-span {
		font-size: 18px;
	}

	.list-base-right {
		display: flex;
		float: right;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 36px;
	}

	.list-base-right-span {
		margin-left: 10px;
	}

	.span-back-color {
		color: #000;
	}

	.div-title {
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 20px;
	}

	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}

	.list-module {
		background-color: white;
		margin-top: 20px;
		padding: 15px;
	}

	.div-content-row div {
		padding: 15px;
	}

	.div-content-row-center div {
		padding: 15px;
		text-align: center;
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}

	.amount-color {
		color: rgb(255, 106, 127);
	}

	.div-content-detail {
		margin: 15px;
		background-color: #f8f8f9;
		padding: 20px;
	}

	.div-content-detail-title {
		text-indent: 0.5em;
		font-weight: bold;
		border-bottom: 1px solid #ebeef5;
	}

	.div-content-detail-list {
		margin-top: 10px;
	}

	.div-content-detail-list-title {
		text-indent: 0.5em;
	}

	.div-content-detail-list-content {
		overflow: hidden;
	}

	.div-content-detail-list-content-item {
		float: left;
		width: 30%;
		padding: 10px;
		text-align: center;
	}

	.extraCostShowTable {
		margin-top: 10px;
		color: #000;
	}

	.extraCostShowTable td {
		padding: 5px;
	}
</style>